<template>
  <fieldset :disabled="viewOnly" style="margin-top: -10px; width: 100%">
    <a-tabs defaultActiveKey="1">
      <a-tab-pane :tab="searchTabName" key="1">
        <div class="row no-gutters">
          <div class="col-md-12 mb-3">
            <b-input-group class="custom-input-group-pane">
              <template v-slot:prepend>
                <b-dropdown :text="filterCaption" variant="outline-default">
                  <b-dropdown-item @click="changeFilter('name')">Name</b-dropdown-item>
                  <b-dropdown-item @click="changeFilter('id')">Product Code</b-dropdown-item>
                  <b-dropdown-item @click="changeFilter('barcode')">Barcode</b-dropdown-item>
                  <b-dropdown-item @click="changeFilter('stock_no')">Stock No</b-dropdown-item>
                  <b-dropdown-item @click="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                  <b-dropdown-item @click="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>
                </b-dropdown>
              </template>
              <b-form-input style="padding: 0px 15px; height: 42px; border-right: 0px" @keydown.enter="allProductsData" v-model="searchText">{{searchText}}</b-form-input>
            </b-input-group>
          </div>
        </div>
        <div class="row" style="max-height: 34rem;">
          <div class="col-md-12">
            <small v-if="products.length > 0">{{products.length}} item{{products.length > 1 ? 's' : ''}} selected</small>
            <div :id="this.tableElement || 'product-table'" class="custom-tabulator"></div>
            <span v-if="runProduct == true" class="d-none">{{allProductsData()}}</span>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane :tab="viewTabName" key="2">
        <div class="col-md-12 px-0 pb-5 table-responsive">
          <table class="table border">
            <thead class="thead-light">
              <tr>
                <th>Name</th>
                <th>Stock No</th>
                <th>Retail Price</th>
                <th v-if="forDiscountedAmount">Discounted Price</th>
                <th width="140px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in products.filter(item => item.sales_channel_product_status != 'Delete')" v-bind:key="index">
                <td class="py-4">{{item.name}}</td>
                <td class="py-4">{{item.stock_no}}</td>
                <td class="py-4">{{item.retail_price}}</td>
                <td v-if="forDiscountedAmount">
                  <a-input v-model="item.item_promotion_price" style="font-size: 13px;" input-classes="form-control" :disabled="viewOnly" />
                </td>
                <td>
                  <button slot="actions" class="btn btn-sm btn-warning p-1" @click="removeProduct(index)">
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </fieldset>
</template>
<script>
  import secureStorage from '../../../controllers/secureStorage.js'
  import { mapState } from 'vuex'
  var Tabulator = require('tabulator-tables')
  var table
  let sleep = function(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  export default {
    props: {
      form: Object,
      products: Array,
      viewOnly: Boolean,
      forDiscountedAmount: Boolean,
      searchTabName: {
        default: 'Search products',
        type: String
      },
      viewTabName: {
        default: 'Selected items',
        type: String
      },
      tableElement: String,
      sales_channel_stores: Object
    },
    data() {
      return {
        filterCaption: 'Search by Name',
        filterField: 'name',
        searchText: '',
        runProduct: false,
        setTable:false,
        options: {
          layout: 'fitDataStretch',
          ajaxURL:'',
          ajaxConfig: {
            method: 'GET',
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem('accessToken'),
              'Access-Control-Allow-Origin': '*'
            },
          },
          pagination: 'remote',
          paginationDataSent: {
            page: 'page',
            size: 'per_page'
          },
          showData: [],
          paginationSize: 10,
          columns: [
            { title: 'Name', field: "name", width: '30%', headerSort: false },
            { title: 'Stock No.', field: "stock_no", width: '30%', headerSort: false },
            { title: 'Retail Price', field: 'retail_price', width: '20%', headerSort: false },
            { title: '', align: 'center', formatter: this.addButton, cellClick: this.selectProductAction, headerSort: false },
          ],
        }
      }
    },
    name: 'product-search-tab',
    computed: {
      ...mapState(['endPoint']),
    },
    methods: {
      changeFilter(value){
        this.filterField = value
        this.filterCaption = "Filter By " + this.capitalize(this.filterField)
      },
      capitalize: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      },
      addProduct(data, postedIndex){
        if(postedIndex < 0) {
          data.item_promotion_price = data.retail_price
          data.collection_index = ''
          data.sales_channel_product_status = 'New'
          if(this.$attrs.action == "Edit")
            data.sales_channel_product_status = 'New'
          this.products.push(data)
        }
        else if(postedIndex >= 0 && this.products[postedIndex].sales_channel_product_status == 'Delete')
          this.products[postedIndex].sales_channel_product_status = ''
        else
          this.errors.push("Product " +this.products[postedIndex].name + " is already exist")
      },
      removeProduct(index){
        var postedIndex = null
        if(this.$attrs.action == 'Create')
          postedIndex = this.products.findIndex(x => x.id == index)
        else
          postedIndex = this.products.findIndex(x => x.product_id == index)
        if(postedIndex == -1)
          postedIndex = index
        if(this.$attrs.action == "Edit")
          if(this.products[postedIndex].sales_channel_product_status != undefined)
            if(this.products[postedIndex].sales_channel_product_status != "New")
              this.products[postedIndex].sales_channel_product_status = "Delete"
            else
              this.products.splice(postedIndex,1)
          else
            this.products[postedIndex].sales_channel_product_status = "Delete"
        else
          this.products.splice(postedIndex,1)
        this.allProductsData();
      },
      addButton: function(cell){
        let id = cell.getRow().getData().id
        var button = ""
        var postedIndex = -1
        if(this.$attrs.action == 'Create')
          postedIndex = this.products.findIndex(x=> x.id == id)
        else{
          postedIndex = this.products.findIndex(x=> x.product_id == id)
          if(postedIndex >= 0)
            postedIndex = this.products[postedIndex].sales_channel_product_status == "Delete" ? -1 : postedIndex
          else{
              postedIndex = this.products.findIndex(x=> x.id == id)
              if(postedIndex >= 0)
                postedIndex = this.products[postedIndex].sales_channel_product_status == "Delete" ? -1 : postedIndex
              else
                postedIndex = this.products.findIndex(x=> x.id == id)
            }
        }
        if(postedIndex <0){
          button += '<button id="' + id + '" name="Add" class="btn btn-success btn-sm">Add</button>'
        }else{
          button += '<button id="' + id + '" name="Remove" class="btn btn-sm btn-warning">Remove</button>'
        }
        return button
      },
      selectProductAction: function(e, cell){
        if(e.target.id !== ""){
          this.errors = []
          var postedIndex = null
          switch (e.target.name){
            case "Add":
              if(this.$attrs.action == 'Create')
                postedIndex = this.products.findIndex(x => x.id == e.target.id)
              else{
                postedIndex = this.products.findIndex(x => x.product_id == e.target.id)
                if(postedIndex < 0)
                  postedIndex = this.products.findIndex(x => x.id == e.target.id)
              }
              this.addProduct(cell.getRow().getData(), postedIndex)
              break;
            case "Remove":
              if(this.$attrs.action == 'Create')
                postedIndex = this.products.findIndex(x => x.id == e.target.id)
              else{
                postedIndex = this.products.findIndex(x => x.product_id == e.target.id)
                if(postedIndex < 0)
                  postedIndex = this.products.findIndex(x => x.id == e.target.id)
              }
              if(this.$attrs.action == "Edit")
                if(this.products[postedIndex].sales_channel_product_status != undefined)
                  if(this.products[postedIndex].sales_channel_product_status != "New")
                    this.products[postedIndex].sales_channel_product_status = "Delete"
                  else
                    this.products.splice(postedIndex,1)
                else
                  this.products[postedIndex].sales_channel_product_status = "Delete"
              else
                this.products.splice(postedIndex,1)
              break;
            default:
              break;
          }
          this.allProductsData()
        }
      },
      allProductsData: async function(){
        this.options.ajaxURL = this.endPoint + 'sales_channel_promotions/get_products?ids=' + Object.keys(this.sales_channel_stores).join(",") + (this.searchText.trim !== "" ? `&${this.filterField}=${this.searchText}` : "")
        // this.options.ajaxURL = this.endPoint + 'products?type=sales_channel'+ (this.searchText.trim !== "" ? `&${this.filterField}=${this.searchText}` : "")
        this.options.paginationInitialPage = 1
        table = await new Tabulator(`#${this.tableElement || 'product-table'}`, this.options);
        this.setTable = true
        this.runProduct = false
      },
    },
    mounted: function(){
      this.allProductsData()
    }
  }
</script>
<style lang='scss'>
    @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
    .custom-input-group-pane * {
      font-size: 13px
    }
    .iframe-container {
      overflow: hidden;
      padding-top: 56.25%; /* 16:9*/
      position: relative;
    }
    .iframe-container iframe {
      border: 0;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  .custom-tabulator .tabulator-loader{
    background: rgba(250,250,250,0.7) !important;
    .tabulator-loader-msg{
      box-shadow: 0px 14px 80px rgba(10, 10, 10, 0.3) !important;
      border-radius: 10px !important;
      border: 0px !important;
      padding: 30px 50px !important;
      font-size: 14px !important;
      font-weight: normal !important;
    }
  }
</style>
